import * as React from 'react';

import { Label } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IEscrowLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  dark?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  ref?: React.Ref<HTMLDivElement>;
}

export const EscrowLabel: React.FC<IEscrowLabelProps> = ({ dark, onClick, ref, ...props }) => {
  return (
    <div className={styles['label']} {...props} onClick={onClick} ref={ref}>
      <Label background={dark ? 'overlay-control-default' : 'surface-neutral-default'} color="theme-dark">
        Эскроу
      </Label>
    </div>
  );
};
